module.exports = __webpack_public_path__ + "static/transposh4-1339269c47accfefd70d2f573c3176d9.jpg";